import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import { IconMapMetroMsk16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './underground.css';

export const Underground = ({ name, color }: { name: string; color: string }) => {
  return (
    <div className={styles['underground']}>
      <div className={styles['icon']} style={{ color }}>
        <IconMapMetroMsk16 color="current_color" />
      </div>
      <UIText1 color="text-primary-default">{name}</UIText1>
    </div>
  );
};
